import type { NavigateFunction } from 'react-router-dom'

// Bridge so non-React code can navigate: <NavigationSetter> captures useNavigate() once the router mounts; earlier calls are no-ops (navigation only follows user actions).
let navigateRef: NavigateFunction | null = null

export const setNavigate = (fn: NavigateFunction) => {
  navigateRef = fn
}

export const navigate: NavigateFunction = ((to: any, options?: any) => navigateRef?.(to, options)) as NavigateFunction
